import { useOrderContext } from "app/providers/OrderProvider";
import { GetOrderResponse } from "shared/api/middleware-api-client";
import Button, { ButtonArrowTypes, ButtonTypes } from "shared/ui/button";
import { concatClassnames } from "shared/utils/concatClassnames";

interface StatusActionButtonsProps {
  className?: string;
}

const StatusActionButtons = ({ className }: StatusActionButtonsProps) => {
  const { order } = useOrderContext();

  const measurementAppointment = (order: GetOrderResponse) => {
    window.location.href =
      "/webshop/checkout?reference=" + order.id + "&type=measurement";
  };

  const placementAppointment = (order: GetOrderResponse) => {
    window.location.href = "/afspraak-maken?type=placement&orderId=" + order.id;
  };

  const shipmentAppointment = (order: GetOrderResponse) => {
    window.location.href = "/afspraak-maken?type=shipment&orderId=" + order.id;
  };

  // Enable status buttons if the order is not a sample sale or self assembly
  const enableStatusButtons =
    !order?.shoppingCart?.sampleSale && !order?.isSelfAssembly;

  return (
    <div
      className={concatClassnames(
        "gg-w-full md:gg-w-2/3 xl:gg-w-1/2",
        className,
      )}
    >
      {enableStatusButtons &&
        (order && order.status === "measurement_pending" ? (
          <Button
            onClick={() => measurementAppointment(order)}
            type={ButtonTypes.YELLOW}
            arrow={ButtonArrowTypes.RIGHT}
          >
            Inmeetafspraak maken
          </Button>
        ) : order && order.status === "placement_pending" ? (
          <Button
            onClick={() => placementAppointment(order)}
            type={ButtonTypes.YELLOW}
            arrow={ButtonArrowTypes.RIGHT}
          >
            Montage-afspraak maken
          </Button>
        ) : order && order.status === "shipment_pending" ? (
          <Button
            onClick={() => shipmentAppointment(order)}
            type={ButtonTypes.YELLOW}
            arrow={ButtonArrowTypes.RIGHT}
          >
            Leveringsafspraak maken
          </Button>
        ) : (
          <></>
        ))}
    </div>
  );
};
export default StatusActionButtons;
